import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';

import styles from './main-loading-style';
import { Typography } from '@material-ui/core';

/**
 * A component to render a global loading spinner before displaying some data on a page
 */
interface MainLoadingProps {
    classes: {
        root: string;
        center: string;
    };
    center?: boolean;
    size?: number;
    message?: string;
}

const MainLoading = (props: MainLoadingProps): JSX.Element => {
    const { classes, center, message, ...res } = props;
    return (
        <div className={center ? classes.center : classes.root}>
            <CircularProgress size={60} {...res} />
            {message && <Typography variant="body1">{message}</Typography>}
        </div>
    );
};

export default withStyles(styles)(MainLoading);
